import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { CustomerRebate, RebateTakeoutOptions } from '@usf/product-types';
import { Router } from '@angular/router';
import { PlatformService } from '@panamax/app-state';
import { ProductAnalyticsService } from '@usf/ngrx-product';
import { getRebateTakeoutOptionEnum } from '@app/rebates/utils/rebates.util';
@Component({
  selector: 'app-rebates-banner',
  templateUrl: './rebates-banner.component.html',
  styleUrls: ['./rebates-banner.component.scss'],
})
export class RebatesBannerComponent implements OnInit {
  TOTAL_WEEKS = 13;
  @Input() incentivePrograms: CustomerRebate[];
  selectedIncentiveProgram: CustomerRebate;
  isEnabled = true;
  bannerInformation: {
    title: string;
    amount: number;
    className: string;
    subtext: string;
  };

  constructor(
    private router: Router,
    protected platformService: PlatformService,
    private analyticsService: ProductAnalyticsService,
  ) {}

  ngOnInit() {
    this.selectedIncentiveProgram = this.incentivePrograms?.find(program =>
      Object.values(RebateTakeoutOptions).some(
        option =>
          Array.isArray(option) && option.includes(program.icmTakeoutOption),
      ),
    );
    const effDate = new Date(this.selectedIncentiveProgram?.icmEffDate);
    const rebateEndDate = new Date(effDate);
    rebateEndDate.setDate(effDate.getDate() + this.TOTAL_WEEKS * 7);
    this.isEnabled = rebateEndDate >= new Date();
    if (
      RebateTakeoutOptions.GetToKnowUs.includes(
        this.selectedIncentiveProgram?.icmTakeoutOption,
      )
    ) {
      this.bannerInformation = {
        title: 'i18n.home.incentivesBanner.growWithUs',
        subtext: 'i18n.home.incentivesBanner.onPaceToEarn',
        amount: this.selectedIncentiveProgram?.toDateAgrTotal,
        className: 'rebate-banner-1',
      };
    } else if (
      RebateTakeoutOptions.PartnerWithUs.includes(
        this.selectedIncentiveProgram?.icmTakeoutOption,
      )
    ) {
      this.bannerInformation = {
        title: 'i18n.home.incentivesBanner.partnerWithUs',
        subtext: 'i18n.home.incentivesBanner.trackYourProgress',
        amount: this.selectedIncentiveProgram?.toDateAgrTotal,
        className: 'rebate-banner-2',
      };
    }
  }

  navigateToRebates() {
    this.analyticsService.trackClickRebatesBanner();
    this.router.navigate([
      'customer-incentives',
      getRebateTakeoutOptionEnum(
        this.selectedIncentiveProgram.icmTakeoutOption,
      ),
    ]);
  }
}
